import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';
import { AMPLAR_EXTERNAL_LINKS, MY_HEALTH_EXTERNAL_LINKS } from 'common/links';

export const useExternalLinks = () => {
  const { systemId } = usePatientPortalContext();
  return systemId === PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH
    ? MY_HEALTH_EXTERNAL_LINKS
    : AMPLAR_EXTERNAL_LINKS;
};
